// extracted by mini-css-extract-plugin
module.exports = {"QuestionIcon":"QuestionIcon_QuestionIcon__oBAkG"};